<template>
  <ButtonGroup
    :isFullWidth="false"
  >
    <Button
      :class="$style.buttonCancel"
      :data-test-id="`AddAccountModalButtons__cancelBtn__${dataTestIdSuffix}`"
      hasOutline
      text="Cancel"
      type="secondary"
      @click="handleCancel"
    />
    <Button
      :data-test-id="`AddAccountModalButtons__nextBtn__${dataTestIdSuffix}`"
      :isDisabled="nextDisabled"
      :isLoading="nextLoading"
      :text="nextText"
      type="secondary"
      @click="handleNext"
    />
  </ButtonGroup>
</template>

<script>
import {
  Button,
  ButtonGroup,
} from '@jumpcloud/ui-components';

export default {
  name: 'AddAccountModalButtons',

  components: {
    Button,
    ButtonGroup,
  },

  props: {
    dataTestIdSuffix: {
      type: String,
      default: '',
    },

    nextDisabled: Boolean,

    nextLoading: Boolean,

    nextText: {
      type: String,
      default: 'Next',
    },
  },

  methods: {
    handleCancel() {
      this.$emit('cancel');
    },

    handleNext() {
      this.$emit('next');
    },
  },
};
</script>

<style module scoped>
.buttonCancel {
  margin-right: 5px;
}
</style>
